import NetxQueryClient from '@netx/core-next/lib/queryClient';
import type {BatchJobId as UUID} from '@netx/core-app/models/batchJob';
import {type IProgressReport} from '../schema';
import {getResponseResults} from '../utils/api';

/**
 * `getProgressReport` request params
 * (what is used to send to server)
 */
export interface GetProgressReportRequestOptions {
	uuid: UUID;
}

/**
 * `getProgressReport` request
 * (what gets sent to the server)
 */
export type GetProgressReportRequest = [
	GetProgressReportRequestOptions['uuid'],
];

/**
 * `getProgressReport` response
 * (what comes back from the server)
 */
export interface GetProgressReportResponse<
	WarningObject extends object = object,
> {
	result: GetProgressReportResult<WarningObject>;
}

/**
 * `getProgressReport` result
 * (what is utilized from the server response)
 */
export type GetProgressReportResult<WarningObject extends object = object> =
	IProgressReport<WarningObject>;

export const getProgressReportEndpoint = 'getProgressReport';

/**
 * Get progress report for uuid
 * @param fetchParams Fetch params
 */
export const getProgressReport = async <WarningObject extends object = object>(
	{uuid}: GetProgressReportRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetProgressReportRequest = [uuid];

	return client
		.post<GetProgressReportResponse<WarningObject>>(
			getProgressReportEndpoint,
			requestParams,
			{
				signal,
			},
		)
		.then(getResponseResults);
};

export default getProgressReport;
